module.exports = __webpack_public_path__ + "static/media/Dribble.13e8f496.png";